<mat-toolbar>
  <button mat-icon-button (click)="onToggleSidenav()">
    <mat-icon>menu</mat-icon>
  </button>

  <app-back-button *ngIf="!hideBackIcon"></app-back-button>
  <h4>{{ title }}</h4>
</mat-toolbar>
